import type { IFlattenedCategory } from "app/common/services/categoryService.types";
import type { ICategoryDataBase } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/types";
import { TRAFFIC_METRIC } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/const";

/**
 * the compareFunctionHof implements the following sorting prioritization;
 * Parent industry -> metric size[e.g. visits]
 * */
export const compareFunctionHof =
    (selectedCategory: IFlattenedCategory) =>
    (categoryData: ICategoryDataBase, secondCategoryData: ICategoryDataBase) => {
        if (selectedCategory.parentItem?.forApi === categoryData.Category) {
            return -1;
        }
        if (selectedCategory.parentItem?.forApi === secondCategoryData.Category) {
            return 1;
        }
        return categoryData[TRAFFIC_METRIC] > secondCategoryData[TRAFFIC_METRIC] ? -1 : 1;
    };
